import { CrosswalkMappingSetType } from 'domains/scope-and-sequence/types'
import React from 'react'
import { Tooltip } from '@mui/material'
import styled from '@emotion/styled'

export function getAlignmentColor(alignment_type: string) {
  switch (alignment_type) {
    case 'full':
      return '#007B4B' // green
    case 'related':
      return '#367BBF' // blue
    case 'partial':
    case 'strong partial':
      return '#A18632' // yellow
    case 'weak partial':
      return '#827AB9' // purple
    default:
      return '#d32f2f' // red
  }
}

const StyledTooltip = styled(
  ({ className, ...props }: React.ComponentProps<typeof Tooltip>) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ),
)`
  & .MuiTooltip-tooltip {
    background: #3e4b4b;
    color: white;
    font-size: 14px;
    line-height: 18px;
    padding: 4px 12px;
    border-radius: 4px;
    position: relative;
    text-transform: capitalize;
  }
`

export function PercentStatusBar({
  alignments,
}: {
  alignments: CrosswalkMappingSetType['alignments']
}) {
  if (!alignments) return null

  const total = alignments.length
  const byType = Object.groupBy(alignments, (x) => x.alignment_type)

  return (
    <section style={{ display: 'flex', borderRadius: 8, overflow: 'hidden' }}>
      {Object.keys(byType)
        .sort()
        .map((key) => {
          // @ts-expect-error key is acting weird
          const count = byType[key]!.length
          const percent = (count / total) * 100
          return (
            <StyledTooltip
              key={key}
              title={`${key} ${percent.toFixed(1)}% (${count ?? 0} / ${total})`}
              followCursor
            >
              <span
                key={key}
                style={{
                  alignContent: 'center',
                  boxSizing: 'border-box',
                  padding: '8px 10px',
                  display: 'inline-block',
                  color: 'white',
                  textAlign: 'center',
                  textTransform: 'capitalize',
                  fontWeight: 'bold',
                  width: `${percent}%`,
                  cursor: 'pointer',
                  backgroundColor: getAlignmentColor(key),
                }}
              >
                {percent > 10 ? `${key} ${percent.toFixed(1)}%` : ''}
              </span>
            </StyledTooltip>
          )
        })}
    </section>
  )
}
